export default (theme) => ({
  document: {
    margin: "15px 0 15px 10px",
  },
});
